import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { StaticQuery } from 'gatsby';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LNB from '../components/LNB';
import Resizable from '../components/Resizable';
var LNB_WIDTH = 260;
var LNB_MIN_WIDTH = 212;
export var Layout = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Layout, _React$Component);

  function Layout() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      width: LNB_WIDTH
    };
    _this.handleMouseMove = _this.changeWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Layout.prototype;

  _proto.changeWidth = function changeWidth(ev) {
    ev.preventDefault(); // to prevent user-select's work

    this.setState({
      width: Math.max(ev.pageX, LNB_MIN_WIDTH)
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        tabIndex = _this$props.tabIndex,
        selectedNavItemId = _this$props.selectedNavItemId,
        children = _this$props.children;
    var header = data.header,
        footer = data.footer,
        useExample = data.useExample;
    var lnbWidth = this.state.width;
    return /*#__PURE__*/React.createElement("div", {
      className: "wrapper"
    }, /*#__PURE__*/React.createElement(Header, {
      data: header
    }), /*#__PURE__*/React.createElement("main", {
      className: "body",
      style: {
        paddingLeft: lnbWidth
      }
    }, /*#__PURE__*/React.createElement(LNB, {
      useExample: useExample,
      tabIndex: tabIndex,
      selectedNavItemId: selectedNavItemId,
      width: lnbWidth
    }), /*#__PURE__*/React.createElement("section", {
      className: "content"
    }, children), /*#__PURE__*/React.createElement(Resizable, {
      left: lnbWidth,
      handleMouseMove: this.handleMouseMove
    })), /*#__PURE__*/React.createElement(Footer, {
      infoList: footer
    }));
  };

  return Layout;
}(React.Component);

var LayoutWrapper = function LayoutWrapper(props) {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "4108157242",
    render: function render(data) {
      return /*#__PURE__*/React.createElement(Layout, Object.assign({
        data: data.allLayoutJson.edges[0].node
      }, props));
    }
  });
};

export default LayoutWrapper;